// import { useEffect } from "react";
import {
  Grid,
  TextField,
  Button,
  Box,
  Stack,
  Typography,
  MenuItem,
  CircularProgress,
  Input
} from "@mui/material";
import { useRef, useState } from 'react';
import { Form as FormikForm, useFormikContext } from "formik";
import { CustomField } from "../../../inputs/CustomField";
import { recomendacionCapacitacion } from "../../../../utils/lists";
import { useAxios } from '../../../../context/AxiosHookContext';
import Iconify from '../../../iconify';

export const TrainingForm = ({ onClose, fileInputRef }) => {
  const { values, isSubmitting, setFieldValue } = useFormikContext();
  const axios = useAxios();
  const [loadingFile, setLoadingFile] = useState(false);
  
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validar tipo de archivo
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        alert('Solo se permiten archivos PDF e imágenes (JPG, PNG)');
        return;
      }
      
      setLoadingFile(true);
      try {
        const formData = new FormData();
        formData.append('file', file);
        
        const response = await axios.post('/files/saveFile', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        if (response.data.success) {
          const fileId = parseInt(response.data.data._id, 10);
          setFieldValue('documento', fileId);
          // Reiniciar el input para permitir seleccionar otro archivo
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
        } else {
          alert(`Error al subir archivo: ${response.data.message}`);
        }
      } catch (error) {
        alert('Error al subir archivo');
      } finally {
        setLoadingFile(false);
      }
    }
  };
  
  return (
    <FormikForm>
      <Stack direction="row" alignItems="center" justifyContent="center" padding={1}>
        <Typography variant="h4" gutterBottom>
          Solicitud de Recomendaciones y Capacitaciones
        </Typography>
      </Stack>

      <Box width="100%" justifyContent="center" display="flex">
        <Grid container xs={12} md={9} lg={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomField
                name="type"
                select
                label="Tipo de Servicio"
                fullWidth
                as={TextField}
              >
                {Object.keys(recomendacionCapacitacion).map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </CustomField>
            </Grid>

    
            <Grid item xs={12}>
              <CustomField
                name="subType"
                select
                label="Subtipo del Servicio"
                fullWidth
                as={TextField}
              >
                {recomendacionCapacitacion[values?.type] &&
                  Object.keys(recomendacionCapacitacion[values?.type]).map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
              </CustomField>
            </Grid>

       
            {recomendacionCapacitacion[values?.type]?.[values?.subType]?.map((field) => (
              <Grid item xs={12} md={6} key={field.name}>
                <CustomField
                  name={field.name}
                  label={field.label}
                  fullWidth
                  as={TextField}
                />
              </Grid>
            ))}
            
            {/* Campo de archivo */}
            <Grid item xs={12}>
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Documento (Opcional)
                </Typography>
                <Button
                  variant="outlined"
                  component="label"
                  startIcon={loadingFile ? <CircularProgress size={20} /> : <Iconify icon="eva:cloud-upload-fill" />}
                  fullWidth
                  disabled={loadingFile}
                  sx={{ height: 56, justifyContent: 'flex-start' }}
                >
                  {loadingFile ? 'Subiendo archivo...' : values.documento ? `Archivo subido - ID: ${values.documento}` : 'Subir archivo (PDF o imagen)'}
                  <Input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleFileChange}
                    sx={{ display: 'none' }}
                  />
                </Button>
                {values.documento && (
                  <Box sx={{ mt: 1 }}>
                    <Button
                      variant="text"
                      size="small"
                      startIcon={<Iconify icon="eva:eye-fill" />}
                      onClick={async () => {
                        try {
                          const response = await axios.get(`/files/${values.documento}`);
                          if (response.data.success) {
                            window.open(response.data.data, '_blank');
                          }
                        } catch (error) {
                          alert('Error al cargar el documento');
                        }
                      }}
                    >
                      Ver documento
                    </Button>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>


          <Grid item sm={12} textAlign="right" mt={3}>
            <Button variant="outlined" onClick={onClose}>
              Cancelar
            </Button>

            <Button
              sx={{ marginLeft: 2 }}
              variant="contained"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting && (
                <CircularProgress size={15} sx={{ color: "white", marginRight: "6px" }} />
              )}
              {isSubmitting ? "Guardando" : "Guardar"}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </FormikForm>
  );
};

export default TrainingForm;
